import React, { useContext } from "react";
import BasicAccountApplicationAPI from "../../api/commercial/basic-account-application";
import {
  ApplicationFlows,
  ApplicationFlowSteps,
} from "../../route/application/authenticated/application-flow/types";
import { ErrorContext } from "../../route/error/provider";
import CompanyMapper from "../home/company-mapper";
import { CompanyModel } from "../home/types";
import GeneralCompanyInformation from "./index";
import GeneralCompanyInformationMapper from "./mapper";
import { GeneralCompanyInformationModel } from "./types";
import { LanguageContext } from "../../context/languageContext";
import { ProductContext } from "../../context/product-context/productContext";
import { BasicAccountApplicationDocument } from "../../api/commercial/generated-types";
import { ProductRefType } from "../../context/product-context/types";

export default function GeneralCompanyInformationAdapter({
  flowType,
  basicAccountApplication,
  triggerReload,
  setStep,
}: {
  flowType: ApplicationFlows;
  basicAccountApplication: BasicAccountApplicationDocument;
  triggerReload: () => void;
  setStep: (step: ApplicationFlowSteps) => void;
}): React.JSX.Element {
  const { setError } = useContext(ErrorContext);
  const { language } = useContext(LanguageContext);
  const { selectedProduct } = useContext(ProductContext);
  const generalCompanyInformationPageModel: GeneralCompanyInformationModel =
    GeneralCompanyInformationMapper.mapDocumentToPageModel(
      basicAccountApplication,
      language,
      selectedProduct,
    );

  const companyPageModel: CompanyModel = CompanyMapper.mapDocumentToPageModel(
    basicAccountApplication.company,
  );

  return (
    <GeneralCompanyInformation
      flowType={flowType}
      initial={generalCompanyInformationPageModel}
      context={{
        companyName: companyPageModel.name,
        selectedProduct: basicAccountApplication.productRef as ProductRefType,
      }}
      previous={() => {
        setStep(ApplicationFlowSteps.COMPANY);
      }}
      next={async (data: GeneralCompanyInformationModel) => {
        try {
          await BasicAccountApplicationAPI.createGeneralCompanyInformation(
            GeneralCompanyInformationMapper.mapPageModelToRequest(
              data,
              basicAccountApplication.applicationRef,
            ),
          );
        } catch (error) {
          setError(error);
        }

        triggerReload();
      }}
    />
  );
}
